var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "landing-gift" }, [
      _c("div", { staticClass: "landing-gift__icon" }, [
        _c("img", {
          attrs: { src: require("@/assets/landing/alert-gift.png"), alt: "" },
        }),
      ]),
      _c("div", { staticClass: "landing-gift__text" }, [
        _vm._v(" Take the quiz and get your "),
        _c("span", [_vm._v("personal plan")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }